import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-147cb8c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 absolute top-8 right-0 m-2 py-4 bg-gray-50 rounded w-auto min-w-max shadow-lg z-50" }
const _hoisted_2 = { class: "menu-section" }
const _hoisted_3 = { class: "menu-item header" }
const _hoisted_4 = { class: "menu-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2 text-xs text-gray-800 font-bold" }, "DISCOVER", -1))
const _hoisted_6 = { class: "menu-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2 text-xs text-gray-800 font-bold" }, "MY ACTIONS", -1))
const _hoisted_8 = { class: "menu-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2 text-xs text-gray-800 font-bold" }, "SUPPORT", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("button", {
        class: "menu-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('journals')))
      }, " Journals "),
      _createElementVNode("button", {
        class: "menu-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('publications')))
      }, " Published Works "),
      _createElementVNode("button", {
        class: "menu-item",
        id: "reviewPageLink",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('users')))
      }, " Users ")
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("button", {
        class: "menu-item",
        id: "createPostPageLink",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPostSidebar && _ctx.openPostSidebar(...args)))
      }, " Create Post "),
      _createElementVNode("button", {
        class: "menu-item",
        id: "invitationsPageLink",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openInvitationsSidebar && _ctx.openInvitationsSidebar(...args)))
      }, " Invite Users "),
      _createElementVNode("button", {
        class: "menu-item",
        id: "myGroksPageLink",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateToUser('/playlists')))
      }, " My Collections "),
      _createElementVNode("button", {
        class: "menu-item",
        id: "accountPageLink",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openProfileSidebar && _ctx.openProfileSidebar(...args)))
      }, " Profile ")
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("button", {
        class: "menu-item",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateToPath('/faqs/top')))
      }, " FAQs "),
      _createElementVNode("button", {
        class: "menu-item",
        id: "supportPageLink",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openSupportSidebar && _ctx.openSupportSidebar(...args)))
      }, " Contact ")
    ]),
    _createElementVNode("button", {
      class: "menu-item red",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, " Logout ")
  ]))
}